/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {restoreDefaultBreaks} from '../api'

export const useMutationRestoreDefaultBreaks = createReactQueryMutationHook('restoreDefaultBreaks', restoreDefaultBreaks)
